var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/* -- Generated File: Do Not Edit ------------------------------------------ */
/* -- Generated from ./scripts/generate.ts -- */
import React from 'react';
import { Icon } from './icon';
export var IconArrowUpRight = React.forwardRef(function (props, ref) {
    return (_jsx(Icon, __assign({ ref: ref }, props, { children: function (_a) {
            var className = _a.className, size = _a.size, restProps = __rest(_a, ["className", "size"]);
            if (size === 'small') {
                return (_jsx("svg", __assign({ className: className, "data-name": "IconArrowUpRight", fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg" }, restProps, { children: _jsx("path", { clipRule: "evenodd", d: "M11.5 5.56056V10.4439H13V3.75C13 3.33579 12.6642 3 12.25 3H5.55623V4.5L10.4392 4.5L3.49788 11.4414L4.55855 12.5021L11.5 5.56056Z", fill: "currentColor", fillRule: "evenodd" }) })));
            }
            if (size === 'large') {
                return (_jsx("svg", __assign({ className: className, "data-name": "IconArrowUpRight", fill: "none", height: "36", viewBox: "0 0 36 36", width: "36", xmlns: "http://www.w3.org/2000/svg" }, restProps, { children: _jsx("path", { clipRule: "evenodd", d: "M25.9995 11.414L25.9993 24.9997L27.9993 24.9997L27.9995 9.00001C27.9995 8.73479 27.8942 8.48044 27.7066 8.2929C27.5191 8.10536 27.2647 8 26.9995 8L11.0002 8.00002L11.0002 10L24.5851 10L7.00008 27.5852L8.4143 28.9994L25.9995 11.414Z", fill: "currentColor", fillRule: "evenodd" }) })));
            }
            if (size === 'jumbo') {
                return (_jsx("svg", __assign({ className: className, "data-name": "IconArrowUpRight", fill: "none", height: "48", viewBox: "0 0 48 48", width: "48", xmlns: "http://www.w3.org/2000/svg" }, restProps, { children: _jsx("path", { clipRule: "evenodd", d: "M35.3323 14.5523L35.3322 33L37.9989 33L37.999 11.3334C37.999 10.9798 37.8586 10.6406 37.6085 10.3906C37.3585 10.1405 37.0193 10.0001 36.6657 10.0001L14.9993 10L14.9993 12.6667L33.4466 12.6667L10 36.1136L11.8856 37.9992L35.3323 14.5523Z", fill: "currentColor", fillRule: "evenodd" }) })));
            }
            return (_jsx("svg", __assign({ className: className, "data-name": "IconArrowUpRight", fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, restProps, { children: _jsx("path", { clipRule: "evenodd", d: "M17 8.41411L17 16.0048H19V6C19 5.44772 18.5523 5 18 5H7.99537V7L15.5857 7L5.00447 17.5813L6.41869 18.9955L17 8.41411Z", fill: "currentColor", fillRule: "evenodd" }) })));
        } })));
});
export default IconArrowUpRight;
IconArrowUpRight.displayName = 'IconArrowUpRight';
IconArrowUpRight.metadata = 'arrow, diagonal, direction, navigation';
//# sourceMappingURL=iconArrowUpRight.js.map